import Configs from "../config";

interface UploadImageResponse {
  id: string;
  status: number;
}

export async function uploadImage(image: Blob): Promise<UploadImageResponse> {
  const formData = new FormData();
  const BlobToFile = new File([image], "image.png", {
    type: "image/png",
  });
  formData.append("file", BlobToFile);

  const reponse = await fetch(`${Configs.BUCKET_URL}/file/local`, {
    body: formData,
    method: "POST",
  });

  const responseObject = await reponse.json();

  return { ...responseObject, status: reponse.status };
}
